import React from 'react';
import styled from 'styled-components';
import { useI18n, SUPPORTED_LOCALES } from '../../i18n/I18nContext';

const Select = styled.select`
  padding: 0.35rem 0.5rem;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.bgElevated};
  color: ${({ theme }) => theme.colors.text};
  font-size: 0.85rem;
`;

export default function LanguageSwitcher() {
  const { locale, setLocale } = useI18n();
  return (
    <Select value={locale} onChange={(e) => setLocale(e.target.value)} aria-label="Language">
      {SUPPORTED_LOCALES.map((l) => (
        <option key={l.code} value={l.code}>{l.label}</option>
      ))}
    </Select>
  );
}
